import {
  redirectToProfileIfNoAccess,
  redirectToProfileIfNotAdmin,
  redirectToProfileIfNotAdminOrTeamlead,
} from '@/settings/router/guards';

const SettingsPage = () => import('@/settings/pages/settings.vue');
const ProfilePage = () => import('@/settings/pages/account/profile.vue');
const GeneralPage = () => import('@/settings/pages/company/general.vue');
const SecurityPage = () => import('@/settings/pages/company/security.vue');
const ApiPage = () => import('@/settings/pages/company/api-key.vue');
const TeamMembersPage = () => import('@/settings/pages/company/team-members.vue');
const JobArchitecturePage = () => import('@/settings/pages/company/job-architecture.vue');
const LayoutSettings = () => import('@/settings/layouts/layout-settings.vue');

export const settingsRoutes = [
  {
    path: '',
    component: LayoutSettings,
    children: [
      {
        path: '/settings',
        name: 'settings',
        redirect: { name: 'settings-account-profile' },
        component: SettingsPage,
        children: [
          {
            path: 'account/profile',
            name: 'settings-account-profile',
            component: ProfilePage,
          },
          {
            path: 'company/general',
            name: 'settings-company-general',
            component: GeneralPage,
            beforeEnter: [redirectToProfileIfNotAdmin, redirectToProfileIfNoAccess('general')],
          },
          {
            path: 'company/team-members',
            name: 'settings-company-team-members',
            component: TeamMembersPage,
            beforeEnter: [redirectToProfileIfNotAdminOrTeamlead, redirectToProfileIfNoAccess('team_members')],
          },
          {
            path: 'company/security',
            name: 'settings-company-security',
            component: SecurityPage,
            beforeEnter: [redirectToProfileIfNotAdmin, redirectToProfileIfNoAccess('security')],
          },
          {
            path: 'company/api',
            name: 'settings-company-api',
            component: ApiPage,
            beforeEnter: [redirectToProfileIfNotAdmin, redirectToProfileIfNoAccess('api')],
          },
          {
            path: 'company/job-architecture',
            name: 'settings-company-job-architecture',
            component: JobArchitecturePage,
            beforeEnter: [redirectToProfileIfNotAdmin, redirectToProfileIfNoAccess('job_architecture')],
          },
        ],
      },
    ],
  },
];
